var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackBordered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 23,
    viewBox: "0 0 33 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 .125)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9B9B9B",
    fillOpacity: 0.771,
    d: "M25.34 11a1 1 0 0 0-1.001-1H11.414l2.873-2.88a.999.999 0 0 0 .002-1.415 1.005 1.005 0 0 0-1.417.007l-4.576 4.576a1.01 1.01 0 0 0 0 1.424l4.576 4.576a1 1 0 0 0 1.417.007c.39-.39.387-1.024-.002-1.414L11.414 12H24.34a.998.998 0 0 0 1.001-1z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 21,
    x: 0.962,
    y: 0.5,
    fillRule: "nonzero",
    stroke: "#B2B2B2",
    rx: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBordered);
export default __webpack_public_path__ + "static/media/back-bordered.65b92b767d4360674a3319709438db96.svg";
export { ForwardRef as ReactComponent };